import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { ApiService, HttpParamsOptions } from '../../api.service';
import { ToastrService } from 'ngx-toastr';
import { DataTableDirective } from 'angular-datatables';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Config } from 'datatables.net';
import Swal from 'sweetalert2';
import { emailPattern, noWhitespaceInRequiredValidator, password_validation, splitPattern } from '../../shared/constants';
import jsQR from 'jsqr';
import * as FileSaver from 'file-saver';
declare var $: any;
import { NgxFileDropEntry } from 'ngx-file-drop';

class DataTablesResponse {
	data!: any[];
	draw!: number;
	recordsFiltered!: number;
	recordsTotal!: number;
}

@Component({
	selector: 'app-vessel-list',
	templateUrl: './vessel-list.component.html',
	styleUrl: './vessel-list.component.scss'
})
export class VesselListComponent implements OnInit, OnDestroy, AfterViewInit {
	breadcrumbList: any[] = [
		{
			path: this.apiService.getHomeURL(),
			name: "Home"
		},
		/* {
			path: '/app/dashboard-mdm',
			name: "MDM"
		}, */
		{
			path: "/app/vessel",
			name: "Vessels"
		}
	];

	@ViewChild(DataTableDirective, { static: false }) datatableElement!: DataTableDirective;
	baseURL = environment.API_URL + "mdm/";
	dtOptions: Config = {};
	dataList: any = [];
	showDeleteLoader: any = null;
	showQRLoader: any = null;
	showMailLoader: any = null;
	showCallLoader: any = null;
	showDeleteLoaderHC: any = null;
	showCreateLoaderHC: any = null;
	showDeleteLoaderCLIP: any = null;
	showCreateLoaderCLIP: any = null;
	showDeleteLoaderMHS: any = null;
	showCreateLoaderMHS: any = null;
	showDeleteLoaderPharma: any = null;
	showCreateLoaderPharma: any = null;
	showDeleteLoaderTraining: any = null;
	showCreateLoaderTraining: any = null;
	showDeleteLoaderUser: any = null;
	showCreateLoaderUser: any = null;
	pagetitle = "Vessel List";
	pageLoading = false;
	allFlagStates: any[] = [];
	flagState: any = null;
	UserModuleAccess: any = "Full";
	showReset2FALoader: any = null;
	updateInventoryLoader = false;
	excelLoader = false;
	fleetList_dropdown: any = [];
	companyList_dropdown: any = [];
	platform_dropdown: any = [
		{ name: "HC", val: "HC" },
		{ name: "Shore Care", val: "CLIP" },
		{ name: "MHS", val: "MHS" },
		{ name: "Pharma", val: "Pharma" },
		{ name: "Training", val: "Training" }
	];
	searchVal: any = "";
	filter: any = {
		company: null,
		fleet: null,
		platform: null,
		owner: null,
	}
	user_type: any = "";
	accessLoader = false;
	moduleForm: FormGroup = this.formBuilder.group({
		cc_emails: [null],
		bcc_emails: [null],
		language: ["English", [Validators.required]]
	});
	languages: any = [
		{ name: "English", val: "English" },
		{ name: "Chinese", val: "Chinese" }
	];
	requiredValidator = Validators.required;
	ownerList: any[] = [];

	constructor(private formBuilder: FormBuilder, private apiService: ApiService, private activeRoute: ActivatedRoute, private toastr: ToastrService, private http: HttpClient) {
		this.accessLoader = true;
		this.apiService.getUserAccess().subscribe((data: any) => {
			this.accessLoader = false;
			try {
				this.user_type = data.res[0].user_type;
				/* let accessObj: any = JSON.parse(data.res[0].UserModuleAccess);
				this.UserModuleAccess = accessObj["USER_Module"]; */
			} catch (error) { }
		}, (error: any) => {
			this.accessLoader = false;
			/* this.UserModuleAccess = "NoAccess"; */
		});
	}

	ngOnInit(): void {
		this.activeRoute.params.subscribe(routeParams => {
			this.rma_dashboard_company_dropdown();
			this.getOwners();
			this.initDatatable();
		});
	}

	ngOnDestroy(): void {

	}

	ngAfterViewInit(): void {

	}

	getOwners() {
		this.apiService.getOwnerDetails({}).subscribe((data: any) => {
			this.ownerList = data.data;
		}, (error) => {
			this.ownerList = [];
		});
	}

	rma_dashboard_company_dropdown() {
		this.apiService.getCompanyDetails({}).subscribe((data: any) => {
			this.companyList_dropdown = data.data;
		}, (error) => {
			this.companyList_dropdown = [];
		});
	}

	rma_dashboard_fleet_dropdown() {
		this.filter.fleet = null;
		let payload: any = {};
		payload["id"] = this.filter.company;
		if (!payload["id"]) {
			this.fleetList_dropdown = [];
			return;
		}
		this.apiService.getFleetsByCompany(payload).subscribe((data: any) => {
			this.fleetList_dropdown = data.data;
		}, (error) => {
			this.fleetList_dropdown = [];
		});
	}

	initDatatable() {
		this.dtOptions = {
			pagingType: 'full_numbers',
			serverSide: true,
			processing: true,
			ordering: false,
			ajax: (dataTablesParameters: any, callback) => {
				this.searchVal = dataTablesParameters.search.value;
				let data: any = {
					draw: dataTablesParameters.draw,
					start: dataTablesParameters.start,
					length: dataTablesParameters.length,
					searchVal: dataTablesParameters.search.value,
				}
				if (this.filter.company) {
					data["company"] = this.filter.company;
				}
				if (this.filter.fleet) {
					data["fleet"] = this.filter.fleet;
				}
				if (this.filter.platform) {
					data["platform"] = this.filter.platform;
				}
				if (this.filter.owner) {
					data["owner"] = this.filter.owner;
				}
				this.apiService.getVesselDetails(data).subscribe({
					next: (response: any) => {
						this.dataList = response.data;
						callback({
							recordsTotal: response.recordsTotal,
							recordsFiltered: response.recordsFiltered,
							data: []
						});
					}, error: (error: any) => {
						if (error.status == 401) { return }
						this.toastr.error("Something went wrong.", 'Error', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}
				});
			}
		}
	}

	deleteConfirm(vessel: any) {
		Swal.fire({
			title: 'Warning !!!',
			html: 'Are you sure you want to delete vessel <p style="text-align:center;font-size: 15px;"><strong>' + vessel.name + '</strong>?</p>',
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Yes, delete it!',
			confirmButtonColor: '#dc3545'
		}).then((result) => {
			if (result.value) {
				this.showDeleteLoader = vessel.id;
				this.apiService.deleteVessel({ id: vessel.id1 }).subscribe({
					next: data => {
						this.showDeleteLoader = null;
						Swal.fire('Success', 'Vessel deleted successfully.', 'success');
						this.refreshTable();
					}, error: (error) => {
						this.showDeleteLoader = null;
						if (error.status == 401) { return }
						if (error.status == 404) {
							Swal.fire('Error', error.error, 'error');
						} else {
							Swal.fire('Error', 'Something went wrong.', 'error');
						}
					}
				});
			}
		})
	}

	deleteVesselForm: FormGroup = this.formBuilder.group({
		id: [null, [this.requiredValidator, noWhitespaceInRequiredValidator]],
		create_new: ["No", [this.requiredValidator, noWhitespaceInRequiredValidator]],
		existing_name: [{ value: null, disabled: true }],
		new_name: [null]
	});

	get f3() { return this.deleteVesselForm.controls; }
	customError3: any = {};
	createErrorMessages: any[] = [];

	clearCustomError3() {
		Object.keys(this.f3).forEach(key => {
			if (this.f3[key].hasError('incorrect')) {
				try {
					delete this.f3[key].errors?.incorrect;
					this.f3[key].updateValueAndValidity();
				} catch (error) {

				}

			}
		});
		this.customError3 = {};
	}

	showError3(field: string) {
		if (this.f3[field].invalid && (this.formSubmitted3 || this.f3[field].touched || this.f3[field].dirty)) {
			return true;
		}
		return false;
	}

	changeNewNameValidation() {
		if (this.f3.create_new.value == "Yes") {
			this.f3.new_name.setValidators([this.requiredValidator]);
		} else {
			this.f3.new_name.clearValidators();
			this.f3.new_name.setValidators(null);
			this.f3.new_name.setValue(null);
		}
		this.f3.new_name.updateValueAndValidity();
	}

	openDeleteVesselModal(vessel: any) {
		this.deleteVesselForm.setValue({
			id: vessel.id1,
			create_new: "No",
			existing_name: vessel.name,
			new_name: null
		});
		this.changeNewNameValidation();
		this.createErrorMessages = [];
		$("#deleteVesselModal").modal("show");
	}

	closeDeleteVesselModal() {
		$("#deleteVesselModal").modal("hide");
	}

	formSubmitted3 = false;
	showLoader3 = false;
	deleteVessel() {
		this.formSubmitted3 = true;
		this.clearCustomError3();
		if (this.deleteVesselForm.invalid) {
			this.toastr.info("Please check required parameters.", 'Warning', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		let payload: any = {
			id: this.f3.id.value
		};
		if (this.f3.create_new.value == "Yes") {
			payload["name"] = this.f3.new_name.value;
		}
		this.showLoader3 = true;
		this.apiService.deleteAndCreateDuplicateVessel(payload).subscribe({
			next: (data: any) => {
				this.showLoader3 = false;
				this.refreshTable();
				if (data.length == 0) {
					let msg = 'Vessel deleted successfully.';
					if (this.f3.create_new.value == "Yes") {
						msg = 'Vessel deleted and new vessel created successfully.';
					}
					Swal.fire('Success', msg, 'success');
					this.closeDeleteVesselModal();
				} else {
					this.createErrorMessages = data;
				}
			}, error: (error: any) => {
				this.showLoader3 = false;
				if (error.status == 401) { return }
				let errorMsg: any = "Something went wrong.";
				if (error.status == 400) {
					errorMsg = error.error;
					if (typeof errorMsg == 'object') {
						for (const [key, value] of Object.entries(errorMsg)) {
							let val: any = value;
							if (val == "This field must be unique.") {
								val = "Already exists";
							}
							if (this.deleteVesselForm.controls[key]) {
								this.deleteVesselForm.controls[key].setErrors({ incorrect: true });
								this.customError3[key] = val;
								let selector = "#" + key;
								try {
									$('html, body').animate({
										scrollTop: $(selector).offset().top - 60 + 'px'
									}, 'fast');
								} catch (error) { }
								$(selector).focus();
							} else {
								this.toastr.error(key + ":" + val, 'Error', {
									timeOut: 3000,
									tapToDismiss: true,
									closeButton: true
								});
							}

						}
						return;
					}
				} else {
					errorMsg = error.error;
				}
				this.toastr.error(errorMsg, 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	sendQR(vessel: any) {
		Swal.fire({
			title: 'Please Confirm',
			html: 'Are you sure you want to send QR code to <p style="text-align:center;font-size: 15px;"><strong>' + vessel.name + '</strong>?</p>',
			icon: 'question',
			showCancelButton: true,
			confirmButtonText: 'Send'
		}).then((result) => {
			if (result.value) {
				this.showQRLoader = vessel.id;
				this.apiService.sendQRCodeToVessel({ id: vessel.id }).subscribe({
					next: data => {
						this.showQRLoader = null;
						Swal.fire('Success', 'QR code sent successfully.', 'success');
						/* this.refreshTable(); */
					}, error: (error) => {
						this.showQRLoader = null;
						if (error.status == 401) { return }
						if (error.status == 404) {
							Swal.fire('Error', error.error, 'error');
						} else {
							Swal.fire('Error', 'Something went wrong.', 'error');
						}
					}
				});
			}
		})
	}

	deleteConfirmHC(uId: any, index: number) {
		let platform = "Health Cube";
		Swal.fire({
			title: 'Warning !!!',
			html: 'Are you sure you want to delete vessel <p style="text-align:center;font-size: 15px;"><strong>' + this.dataList[index].name + '</strong> from ' + platform + '?</p>',
			icon: 'warning',
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: 'Yes, delete it!',
			cancelButtonText: 'Cancel',
			confirmButtonColor: '#dc3545'
		}).then((result) => {
			if (result.value) {
				this.showDeleteLoaderHC = index;
				this.apiService.deleteHCVessel({ id: uId }).subscribe(data => {
					this.showDeleteLoaderHC = null;
					Swal.fire('Success', 'Vessel deleted successfully from ' + platform + '.', 'success');
					this.refreshTable();
				}, (error) => {
					this.showDeleteLoaderHC = null;
					if (error.status == 401) { return }
					if (error.status == 404) {
						Swal.fire('Error', error.error, 'error');
					} else {
						Swal.fire('Error', 'Something went wrong.', 'error');
					}
				});
			} else if (result.dismiss === Swal.DismissReason.cancel) { }
		})
	}

	createConfirmHC(uId: any, index: number) {
		let platform = "Health Cube";
		Swal.fire({
			title: 'Warning !!!',
			html: 'Are you sure you want to create vessel <p style="text-align:center;font-size: 15px;"><strong>' + this.dataList[index].name + '</strong> in ' + platform + '?</p>',
			icon: 'warning',
			showConfirmButton: true,
			showCancelButton: true,
			confirmButtonText: 'Yes, create!',
			cancelButtonText: 'Cancel',
			confirmButtonColor: '#198754'
		}).then((result) => {
			if (result.value) {
				this.showCreateLoaderHC = index;
				this.apiService.createUpdateVesselInHC({ id: uId }).subscribe(data => {
					this.showCreateLoaderHC = null;
					Swal.fire('Success', 'Vessel created successfully in ' + platform + '.', 'success');
					this.refreshTable();
				}, (error) => {
					this.showCreateLoaderHC = null;
					if (error.status == 401) { return }
					if (error.status == 404 || error.status == 400) {
						Swal.fire('Error', error.error.error ? error.error.error : 'Something went wrong.', 'error');
					} else {
						Swal.fire('Error', 'Something went wrong.', 'error');
					}
				});
			} else if (result.dismiss === Swal.DismissReason.cancel) { }
		})
	}

	deleteConfirmCLIP(uId: any, index: number) {
		let platform = "Shore Care";
		Swal.fire({
			title: 'Warning !!!',
			html: 'Are you sure you want to delete vessel <p style="text-align:center;font-size: 15px;"><strong>' + this.dataList[index].name + '</strong> from ' + platform + '?</p>',
			icon: 'warning',
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: 'Yes, delete it!',
			cancelButtonText: 'Cancel',
			confirmButtonColor: '#dc3545'
		}).then((result) => {
			if (result.value) {
				this.showDeleteLoaderCLIP = index;
				this.apiService.deleteCLIPVessel({ id: uId }).subscribe(data => {
					this.showDeleteLoaderCLIP = null;
					Swal.fire('Success', 'Vessel deleted successfully from ' + platform + '.', 'success');
					this.refreshTable();
				}, (error) => {
					this.showDeleteLoaderCLIP = null;
					if (error.status == 401) { return }
					if (error.status == 404) {
						Swal.fire('Error', error.error, 'error');
					} else {
						Swal.fire('Error', 'Something went wrong.', 'error');
					}
				});
			} else if (result.dismiss === Swal.DismissReason.cancel) { }
		})
	}

	createConfirmCLIP(uId: any, index: number) {
		let platform = "Shore Care";
		Swal.fire({
			title: 'Warning !!!',
			html: 'Are you sure you want to create vessel <p style="text-align:center;font-size: 15px;"><strong>' + this.dataList[index].name + '</strong> in ' + platform + '?</p>',
			icon: 'warning',
			showConfirmButton: true,
			showCancelButton: true,
			confirmButtonText: 'Yes, create!',
			cancelButtonText: 'Cancel',
			confirmButtonColor: '#198754'
		}).then((result) => {
			if (result.value) {
				this.showCreateLoaderCLIP = index;
				this.apiService.createUpdateVesselInClip({ id: uId }).subscribe(data => {
					this.showCreateLoaderCLIP = null;
					Swal.fire('Success', 'Vessel created successfully in ' + platform + '.', 'success');
					this.refreshTable();
				}, (error) => {
					this.showCreateLoaderCLIP = null;
					if (error.status == 401) { return }
					if (error.status == 404 || error.status == 400) {
						Swal.fire('Error', error.error.error ? error.error.error : 'Something went wrong.', 'error');
					} else {
						Swal.fire('Error', 'Something went wrong.', 'error');
					}
				});
			} else if (result.dismiss === Swal.DismissReason.cancel) { }
		})
	}

	deleteConfirmMHS(uId: any, index: number) {
		let platform = "MHS";
		Swal.fire({
			title: 'Warning !!!',
			html: 'Are you sure you want to delete vessel <p style="text-align:center;font-size: 15px;"><strong>' + this.dataList[index].name + '</strong> from ' + platform + '?</p>',
			icon: 'warning',
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: 'Yes, delete it!',
			cancelButtonText: 'Cancel',
			confirmButtonColor: '#dc3545'
		}).then((result) => {
			if (result.value) {
				this.showDeleteLoaderMHS = index;
				this.apiService.deleteMHSVessel({ id: uId }).subscribe(data => {
					this.showDeleteLoaderMHS = null;
					Swal.fire('Success', 'Vessel deleted successfully from ' + platform + '.', 'success');
					this.refreshTable();
				}, (error) => {
					this.showDeleteLoaderMHS = null;
					if (error.status == 401) { return }
					if (error.status == 404) {
						Swal.fire('Error', error.error, 'error');
					} else {
						Swal.fire('Error', 'Something went wrong.', 'error');
					}
				});
			} else if (result.dismiss === Swal.DismissReason.cancel) { }
		})
	}

	createConfirmMHS(uId: any, index: number) {
		let platform = "MHS";
		Swal.fire({
			title: 'Warning !!!',
			html: 'Are you sure you want to create vessel <p style="text-align:center;font-size: 15px;"><strong>' + this.dataList[index].name + '</strong> in ' + platform + '?</p>',
			icon: 'warning',
			showConfirmButton: true,
			showCancelButton: true,
			confirmButtonText: 'Yes, create!',
			cancelButtonText: 'Cancel',
			confirmButtonColor: '#198754'
		}).then((result) => {
			if (result.value) {
				this.showCreateLoaderMHS = index;
				this.apiService.createUpdateVesselInMHS({ id: uId }).subscribe(data => {
					this.showCreateLoaderMHS = null;
					Swal.fire('Success', 'Vessel created successfully in ' + platform + '.', 'success');
					this.refreshTable();
				}, (error) => {
					this.showCreateLoaderMHS = null;
					if (error.status == 401) { return }
					if (error.status == 404 || error.status == 400) {
						Swal.fire('Error', error.error.error ? error.error.error : 'Something went wrong.', 'error');
					} else {
						Swal.fire('Error', 'Something went wrong.', 'error');
					}
				});
			} else if (result.dismiss === Swal.DismissReason.cancel) { }
		})
	}

	deleteConfirmPharma(uId: any, index: number) {
		let platform = "Pharma";
		Swal.fire({
			title: 'Warning !!!',
			html: 'Are you sure you want to delete vessel <p style="text-align:center;font-size: 15px;"><strong>' + this.dataList[index].name + '</strong> from ' + platform + '?</p>',
			icon: 'warning',
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: 'Yes, delete it!',
			cancelButtonText: 'Cancel',
			confirmButtonColor: '#dc3545'
		}).then((result) => {
			if (result.value) {
				this.showDeleteLoaderPharma = index;
				this.apiService.deletePharmaVessel({ id: uId }).subscribe(data => {
					this.showDeleteLoaderPharma = null;
					Swal.fire('Success', 'Vessel deleted successfully from ' + platform + '.', 'success');
					this.refreshTable();
				}, (error) => {
					this.showDeleteLoaderPharma = null;
					if (error.status == 401) { return }
					if (error.status == 404) {
						Swal.fire('Error', error.error, 'error');
					} else {
						Swal.fire('Error', 'Something went wrong.', 'error');
					}
				});
			} else if (result.dismiss === Swal.DismissReason.cancel) { }
		})
	}

	createConfirmPharma(uId: any, index: number) {
		let platform = "Pharma";
		Swal.fire({
			title: 'Warning !!!',
			html: 'Are you sure you want to create vessel <p style="text-align:center;font-size: 15px;"><strong>' + this.dataList[index].name + '</strong> in ' + platform + '?</p>',
			icon: 'warning',
			showConfirmButton: true,
			showCancelButton: true,
			confirmButtonText: 'Yes, create!',
			cancelButtonText: 'Cancel',
			confirmButtonColor: '#198754'
		}).then((result) => {
			if (result.value) {
				this.showCreateLoaderPharma = index;
				this.apiService.createUpdateVesselInPharma({ id: uId }).subscribe(data => {
					this.showCreateLoaderPharma = null;
					Swal.fire('Success', 'Vessel created successfully in ' + platform + '.', 'success');
					this.refreshTable();
				}, (error) => {
					this.showCreateLoaderPharma = null;
					if (error.status == 401) { return }
					if (error.status == 404 || error.status == 400) {
						Swal.fire('Error', error.error.error ? error.error.error : 'Something went wrong.', 'error');
					} else {
						Swal.fire('Error', 'Something went wrong.', 'error');
					}
				});
			} else if (result.dismiss === Swal.DismissReason.cancel) { }
		})
	}

	deleteConfirmTraining(uId: any, index: number) {
		let platform = "Training";
		Swal.fire({
			title: 'Warning !!!',
			html: 'Are you sure you want to delete vessel <p style="text-align:center;font-size: 15px;"><strong>' + this.dataList[index].name + '</strong> from ' + platform + '?</p>',
			icon: 'warning',
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: 'Yes, delete it!',
			cancelButtonText: 'Cancel',
			confirmButtonColor: '#dc3545'
		}).then((result) => {
			if (result.value) {
				this.showDeleteLoaderTraining = index;
				this.apiService.deleteTrainingVessel({ id: uId }).subscribe(data => {
					this.showDeleteLoaderTraining = null;
					Swal.fire('Success', 'Vessel deleted successfully from ' + platform + '.', 'success');
					this.refreshTable();
				}, (error) => {
					this.showDeleteLoaderTraining = null;
					if (error.status == 401) { return }
					if (error.status == 404) {
						Swal.fire('Error', error.error, 'error');
					} else {
						Swal.fire('Error', 'Something went wrong.', 'error');
					}
				});
			} else if (result.dismiss === Swal.DismissReason.cancel) { }
		})
	}

	createConfirmTraining(uId: any, index: number) {
		let platform = "Training";
		Swal.fire({
			title: 'Warning !!!',
			html: 'Are you sure you want to create vessel <p style="text-align:center;font-size: 15px;"><strong>' + this.dataList[index].name + '</strong> in ' + platform + '?</p>',
			icon: 'warning',
			showConfirmButton: true,
			showCancelButton: true,
			confirmButtonText: 'Yes, create!',
			cancelButtonText: 'Cancel',
			confirmButtonColor: '#198754'
		}).then((result) => {
			if (result.value) {
				this.showCreateLoaderTraining = index;
				this.apiService.createUpdateVesselInTraining({ id: uId }).subscribe(data => {
					this.showCreateLoaderTraining = null;
					Swal.fire('Success', 'Vessel created successfully in ' + platform + '.', 'success');
					this.refreshTable();
				}, (error) => {
					this.showCreateLoaderTraining = null;
					if (error.status == 401) { return }
					if (error.status == 404 || error.status == 400) {
						Swal.fire('Error', error.error.error ? error.error.error : 'Something went wrong.', 'error');
					} else {
						Swal.fire('Error', 'Something went wrong.', 'error');
					}
				});
			} else if (result.dismiss === Swal.DismissReason.cancel) { }
		})
	}

	deleteConfirmUser(uId: any, index: number) {
		Swal.fire({
			title: 'Warning !!!',
			html: 'Are you sure you want to delete DOC user of <p style="text-align:center;font-size: 15px;"><strong>' + this.dataList[index].name + '</strong>?</p>',
			icon: 'warning',
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: 'Yes, delete it!',
			cancelButtonText: 'Cancel',
			confirmButtonColor: '#dc3545'
		}).then((result) => {
			if (result.value) {
				this.showDeleteLoaderUser = index;
				this.apiService.deleteDOCUser({ id: uId, type: "Vessel" }).subscribe(data => {
					this.showDeleteLoaderUser = null;
					Swal.fire('Success', 'DOC user deleted successfully.', 'success');
					this.refreshTable();
				}, (error) => {
					this.showDeleteLoaderUser = null;
					if (error.status == 401) { return }
					if (error.status == 404) {
						Swal.fire('Error', error.error, 'error');
					} else {
						Swal.fire('Error', 'Something went wrong.', 'error');
					}
				});
			} else if (result.dismiss === Swal.DismissReason.cancel) { }
		})
	}

	createConfirmUser(uId: any, index: number) {
		Swal.fire({
			title: 'Warning !!!',
			html: 'Are you sure you want to create DOC user for <p style="text-align:center;font-size: 15px;"><strong>' + this.dataList[index].name + '</strong>?</p>',
			icon: 'warning',
			showConfirmButton: true,
			showCancelButton: true,
			confirmButtonText: 'Yes, create!',
			cancelButtonText: 'Cancel',
			confirmButtonColor: '#198754'
		}).then((result) => {
			if (result.value) {
				this.showCreateLoaderUser = index;
				this.apiService.createUpdateDOCUser({ id: uId, type: "Vessel" }).subscribe(data => {
					this.showCreateLoaderUser = null;
					Swal.fire('Success', 'DOC user created successfully.', 'success');
					this.refreshTable();
				}, (error) => {
					this.showCreateLoaderUser = null;
					if (error.status == 401) { return }
					if (error.status == 404 || error.status == 400) {
						Swal.fire('Error', error.error.error ? error.error.error : 'Something went wrong.', 'error');
					} else {
						Swal.fire('Error', 'Something went wrong.', 'error');
					}
				});
			} else if (result.dismiss === Swal.DismissReason.cancel) { }
		})
	}

	refreshTable() {
		this.datatableElement.dtInstance.then((dtInstance) => {
			dtInstance.draw();
		});
	}

	updateVesselInventory() {
		Swal.fire({
			title: 'Please confirm !!!',
			html: '<p>Are you sure you want to update vessel inventory?</p>',
			icon: 'question',
			showCancelButton: true,
			confirmButtonText: 'Update',
			confirmButtonColor: '#198754'
		}).then((result) => {
			if (result.value) {
				this.updateInventoryLoader = true;
				this.apiService.updateVesselInventary().subscribe(data => {
					this.updateInventoryLoader = false;
					Swal.fire('Success', 'Vessel inventory updated successfully', 'success');
				}, (error) => {
					this.updateInventoryLoader = false;
					if (error.status == 401) { return }
					Swal.fire('Error', 'Something went wrong.', 'error');
				});
			} else if (result.dismiss === Swal.DismissReason.cancel) { }
		})
	}

	downloadExcel() {
		let payload: any = {};
		if (this.searchVal) {
			payload["searchVal"] = this.searchVal;
		}
		if (this.filter.company) {
			payload["company"] = this.filter.company;
		}
		if (this.filter.fleet) {
			payload["fleet"] = this.filter.fleet;
		}
		if (this.filter.platform) {
			payload["platform"] = this.filter.platform;
		}
		if (this.filter.owner) {
			payload["owner"] = this.filter.owner;
		}
		this.excelLoader = true;
		this.apiService.mdm_vessel_download(payload).subscribe(data => {
			this.excelLoader = false;
			let excelData: any = data.body;
			let blob = new Blob([excelData], { type: "application/ms-excel" });
			let fileName = "Vessels" + ".xlsx";
			FileSaver.saveAs(blob, fileName);
		}, (error) => {
			this.excelLoader = false;
			if (error.status == 401) { return }
			Swal.fire('Error', 'Something went wrong.', 'error');
		});
	}

	clipText(text: any, limit: any) {
		if (!text) {
			return text;
		}
		limit = limit ? parseInt(limit, 10) : 10;
		let trail = '...';
		return text.length > limit ? text.substring(0, limit) + trail : text;
	}

	mailIndex: any = null;
	mailUId: any = null;

	get f1() { return this.moduleForm.controls; }

	showError1(field: string) {
		if (this.f1[field].invalid && (this.f1[field].touched || this.f1[field].dirty)) {
			return true;
		}
		return false;
	}

	openSendMailModal(uId: any, index: number) {
		if (!this.dataList[index].email) {
			this.toastr.error("No email id in vessel", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		this.mailIndex = index;
		this.mailUId = uId;
		$("#sendMailModal").modal("show");
	}

	clearSendMailModal() {
		this.showMailLoader = null;
		this.mailIndex = null;
		this.mailUId = null;
		this.moduleForm.reset();
		this.f1.language.setValue("English");
		$("#sendMailModal").modal("hide");
	}

	sendMail() {
		if (!this.dataList[this.mailIndex].email) {
			this.toastr.error("No email id in vessel", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		this.showMailLoader = this.mailIndex;
		let payload: any = {
			id: this.mailUId,
			cc_emails: this.f1.cc_emails.value ? this.f1.cc_emails.value : [],
			bcc_emails: this.f1.bcc_emails.value ? this.f1.bcc_emails.value : [],
			language: this.f1.language.value
		}
		this.apiService.sendWelcomeMail(payload).subscribe(data => {
			this.clearSendMailModal();
			this.toastr.success("Mail sent successfully", 'Success', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
		}, (error) => {
			this.showMailLoader = null;
			if (error.status == 401) { return }
			this.toastr.error("Something went wrong", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
		});
	}

	createForm: FormGroup = this.formBuilder.group({
		company: [null, [this.requiredValidator, noWhitespaceInRequiredValidator]],
		fleet: [null, [this.requiredValidator, noWhitespaceInRequiredValidator]],
		poc: [null],
		owner: [null/* , [this.requiredValidator, noWhitespaceInRequiredValidator] */],
	});
	createExcel!: File | null;

	get f2() { return this.createForm.controls; }
	customError2: any = {};
	excel_template_url = environment.File_Storage_URL + "cdm_prod/vessel_format/vessel_bulk.xlsx";

	clearCustomError2() {
		Object.keys(this.f2).forEach(key => {
			if (this.f2[key].hasError('incorrect')) {
				try {
					delete this.f2[key].errors?.incorrect;
					this.f2[key].updateValueAndValidity();
				} catch (error) {

				}

			}
		});
		this.customError2 = {};
	}

	showError2(field: string) {
		if (this.f2[field].invalid && (this.formSubmitted2 || this.f2[field].touched || this.f2[field].dirty)) {
			return true;
		}
		return false;
	}

	openExcelUploadModal() {
		this.createForm.reset();
		this.fleetList = [];
		this.getPOCList();
		$("#excelUploadModal").modal("show");
	}

	closeExcelUploadModal() {
		$("#excelUploadModal").modal("hide");
	}

	fleetList: any[] = [];
	getFleetList() {
		this.f2.fleet.setValue(null);
		if (this.f2.company.value) {
			this.apiService.getFleetsByCompany({ id: this.f2.company.value }).subscribe({
				next: (data: any) => {
					this.fleetList = data.data;
				}, error: (error) => {
					this.fleetList = [];
				}
			});
		} else {
			this.fleetList = [];
		}
	}

	pocList: any[] = [];
	getPOCList() {
		this.apiService.getPocDetails({}).subscribe({
			next: (data: any) => {
				data.data.map((person: any) => {
					try {
						person.full_name = person.f_name + " " + person.l_name;
					} catch (error) {
						person.full_name = person.f_name;
					}
					return person;
				})
				this.pocList = data.data;
			}, error: (error) => {
				this.pocList = [];
			}
		});
	}

	getFleetDetails() {
		if (this.f2.fleet.value) {
			this.apiService.getFleetDetails({ "id": this.f2.fleet.value.id1 }).subscribe({
				next: (data: any) => {
					let poc: any;
					try {
						poc = JSON.parse(data.data.contact_person);
					} catch (error) {
						poc = [];
					}
					this.f2.poc.setValue(poc);
				}, error: (error) => {
					this.pageLoading = false;
					if (error.status == 401) { return }
					this.toastr.error("Unable to fetch details.", 'Error', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true
					});
				}
			});
		} else {
			this.f2.poc.setValue(null);
		}
	}

	public fileSelected(files: NgxFileDropEntry[]) {
		let droppedFile = files[0];
		if (droppedFile.fileEntry.isFile) {
			const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
			fileEntry.file((file: File) => {
				if (this.isExcel(file.name)) {
					this.createExcel = file;
				} else {
					this.createExcel = null;
					this.toastr.error("Invalid File Format.", 'Error', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true
					});
				}
			});
		} else {
			this.createExcel = null;
			this.toastr.error("Invalid File Format.", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
		}
	}

	isExcel(name: string) {
		try {
			const ext: string = name.split(".").pop() || "";
			const ext_lower = ext.toLowerCase();
			return ext_lower == "xlsx" || ext_lower == "xls" || ext_lower == "xlsm";
		} catch (error) {
			return false;
		}
	}

	formSubmitted2 = false;
	showLoader2 = false;
	saveData() {
		this.formSubmitted2 = true;
		this.clearCustomError2();
		if (this.createForm.invalid || !this.createExcel) {
			this.toastr.info("Please check required parameters.", 'Warning', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		if (!this.isExcel(this.createExcel.name)) {
			this.toastr.info("Please select excel file.", 'Warning', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		/* let payload: any = {
			company: this.f2.company.value,
			fleet: this.f2.fleet.value ? this.f2.fleet.value.id : null,
			poc: this.f2.poc.value
		}; */
		const payload = new FormData();
		payload.append("owner", this.f2.owner.value || "");
		payload.append("company", this.f2.company.value);
		payload.append("fleet", this.f2.fleet.value ? this.f2.fleet.value.id : "");
		payload.append("poc", JSON.stringify(this.f2.poc.value || []));
		payload.append("file", this.createExcel);
		this.showLoader2 = true;
		this.apiService.createVesselsFromExcel(payload).subscribe({
			next: (data: any) => {
				this.showLoader2 = false;
				/* this.toastr.success("Saved successfully.", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				}); */
				Swal.fire({
					title: 'Excel uploaded',
					html: `
						<p class="text-start mb-0">Created: ${data.created}</p>
						<p class="text-start mb-0">Updated: ${data.updated}</p>
						<p class="text-start mb-0">Failed: ${data.failed}</p>
					`,
					icon: 'info'
				});
				this.refreshTable();
				this.closeExcelUploadModal();
			}, error: (error: any) => {
				this.showLoader2 = false;
				if (error.status == 401) { return }
				if (error.status == 409) {
					/* Swal.fire({
						title: 'Already Exists',
						html: 'Vessel already exists. Do you want to restore it?',
						icon: 'question',
						showCancelButton: true,
						showConfirmButton: true,
						confirmButtonText: 'Yes, Restore!',
						cancelButtonText: 'Cancel',
						confirmButtonColor: '#3e4fb1'
					}).then((result) => {
						if (result.value) {
							this.apiService.restoreVessel(error.error.id).subscribe((data: any) => {
								this.toastr.success("Vessel restored successfully", 'Success', {
									timeOut: 3000,
									tapToDismiss: true,
									closeButton: true
								});
								this.closeExcelUploadModal();
							}, (error) => {
								this.toastr.error("Something went wrong", 'Error', {
									timeOut: 3000,
									tapToDismiss: true,
									closeButton: true
								});
							});
						} else if (result.dismiss === Swal.DismissReason.cancel) { }
					}) */
				} else {
					let errorMsg: any = "Something went wrong.";
					if (error.status == 400) {
						errorMsg = error.error;
						if (typeof errorMsg == 'object') {
							for (const [key, value] of Object.entries(errorMsg)) {
								let val: any = value;
								if (val == "This field must be unique.") {
									val = "Already exists";
								}
								if (this.createForm.controls[key]) {
									this.createForm.controls[key].setErrors({ incorrect: true });
									this.customError2[key] = val;
									let selector = "#" + key;
									try {
										$('html, body').animate({
											scrollTop: $(selector).offset().top - 60 + 'px'
										}, 'fast');
									} catch (error) { }
									$(selector).focus();
								} else {
									this.toastr.error(key + ":" + val, 'Error', {
										timeOut: 3000,
										tapToDismiss: true,
										closeButton: true
									});
								}

							}
							return;
						}
					} else {
						errorMsg = error.error;
					}
					this.toastr.error(errorMsg, 'Error', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true
					});
				}
			}
		});
	}

	setCalledDate(uId: any, index: number) {
		this.showCallLoader = index;
		this.apiService.setCallDone({ id: uId }).subscribe(data => {
			this.showCallLoader = null;
			this.toastr.success("Saved successfully", 'Success', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			this.refreshTable();
		}, (error) => {
			this.showCallLoader = null;
			if (error.status == 401) { return }
			this.toastr.error("Something went wrong", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
		});
		/* Swal.fire({
			title: 'Warning !!!',
			html: 'Are you sure you want to set call done status for vessel <p style="text-align:center;font-size: 15px;"><strong>' + this.dataList[index].name + '</strong>?</p>',
			icon: 'warning',
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: 'Yes',
			cancelButtonText: 'Cancel'
		}).then((result) => {
			if (result.value) {
				this.showCallLoader = index;
				this.apiService.setCallDone({ id: uId }).subscribe(data => {
					this.showCallLoader = null;
					Swal.fire('Success', 'Saved successfully.', 'success');
					this.refreshTable();
				}, (error) => {
					this.showCallLoader = null;
					if (error.status == 401) { return }
					if (error.status == 404) {
						Swal.fire('Error', error.error, 'error');
					} else {
						Swal.fire('Error', 'Something went wrong.', 'error');
					}
				});
			} else if (result.dismiss === Swal.DismissReason.cancel) { }
		}) */
	}

	resetPassDOCLoader: any = null;
	resetDOCPassword(id: any) {
		Swal.fire({
			title: 'Please confirm !!!',
			html: '<p>Are you sure you want to reset password?</p>',
			icon: 'question',
			showCancelButton: true,
			confirmButtonText: 'Reset',
			confirmButtonColor: '#198754'
		}).then((result) => {
			if (result.value) {
				this.resetPassDOCLoader = id;
				const payload = {
					id: id,
					type: "Vessel",
					reset: true
				}
				this.apiService.createUpdateDOCUser(payload).subscribe({
					next: data => {
						this.resetPassDOCLoader = null;
						this.toastr.success("Password updated successfully", 'Success', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}, error: (error) => {
						this.resetPassDOCLoader = null;
						if (error.status == 401) { return }
						Swal.fire('Error', 'Something went wrong.', 'error');
					}
				});
			}
		})
	}

	mhsQRVessel: any;
	showGetMHSQRLoader: any = null;
	showSendMHSQRLoader: any = null;
	mailIdPlaceholder = "Please add email address and press space bar.";
	public emailvalidators: any = [this.emailPatternValidator];
	public emailerrormessages = { 'emailerr': 'Please enter valid email-id' };
	emailPatternValidator(control: FormControl) {
		if (!control.value.match(emailPattern)) {
			return {
				'emailerr': true
			};
		}
		return null;
	};
	splitPattern = splitPattern;

	private decodeQRCodeFromBlob(blob: Blob) {
		const reader = new FileReader();
		reader.onload = (event: any) => {
			const image = new Image();
			image.onload = () => {
				const canvas = document.createElement('canvas');
				const context = canvas.getContext('2d');
				if (!context) return;
				canvas.width = image.width;
				canvas.height = image.height;
				context.drawImage(image, 0, 0, image.width, image.height);
				const imgData = context.getImageData(0, 0, image.width, image.height);
				const code = jsQR(imgData.data, imgData.width, imgData.height);
				if (code) {
					this.mhsQRVessel.decodedQrText = code.data;
				} else {
					this.mhsQRVessel.decodedQrText = null;
				}
				console.log("QR Content Found:", this.mhsQRVessel.decodedQrText);
			};
			image.src = event.target.result;
		};
		reader.readAsDataURL(blob);
	}

	copyQRLink() {
		navigator.clipboard.writeText(this.mhsQRVessel.decodedQrText).then(() => {
			this.toastr.success("Link copied to clipboard", 'Success', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
		}).catch(err => {
			this.toastr.error("Something went wrong", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
		});
	}

	open_MHS_QR_Modal(vessel: any) {
		this.mhsQRVessel = vessel;
		if (environment.production) {
			this.mhsQRVessel.cc_emails = ["fleetcare@fleetship.com", "randhirmahadik@fleetship.com", "divya.nair@fleetship.com"];
		} else {
			this.mhsQRVessel.cc_emails = ["rpatel@3cubemedicare.com"];
		}
		this.showGetMHSQRLoader = this.mhsQRVessel.id;
		this.apiService.download_MHS_QR(this.mhsQRVessel.id, true).subscribe({
			next: (data) => {
				let imageData: any = data.body;
				let blob = new Blob([imageData], { type: "image/png" });
				this.mhsQRVessel.qrImageBlob = blob;
				this.mhsQRVessel.qrImageUrl = URL.createObjectURL(blob);
				this.showGetMHSQRLoader = null;
				this.decodeQRCodeFromBlob(blob);
				$("#mhsQRModal").modal("show");
			}, error: (error) => {
				this.showGetMHSQRLoader = null;
				this.clear_MHS_QR_Modal();
				if (error.status == 401) { return }
				this.toastr.error("Something went wrong", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	clear_MHS_QR_Modal() {
		this.mhsQRVessel = null;
		$("#mhsQRModal").modal("hide");
	}

	send_MHS_QR() {
		this.showSendMHSQRLoader = this.mhsQRVessel.id;
		this.apiService.download_MHS_QR(this.mhsQRVessel.id, false, this.mhsQRVessel.cc_emails).subscribe({
			next: (data) => {
				this.showSendMHSQRLoader = null;
				this.toastr.success("Sent successfully", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}, error: (error) => {
				this.showSendMHSQRLoader = null;
				if (error.status == 401) { return }
				this.toastr.error("Something went wrong", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	save_MHS_QR() {
		let fileName = this.mhsQRVessel.name + " QR-code" + ".png";
		FileSaver.saveAs(this.mhsQRVessel.qrImageBlob, fileName);
	}

	vesselNameHistoryLoader: any = null;
	vesselNameHistory: any[] = [];
	historyVessel: any = null;
	getVesselNameHistory(vessel: any) {
		this.vesselNameHistory = [];
		this.historyVessel = vessel;
		this.vesselNameHistoryLoader = vessel.id;
		this.apiService.getVesselNameHistory(vessel.id1).subscribe({
			next: (data: any) => {
				this.vesselNameHistoryLoader = null;
				this.vesselNameHistory = data;
				$("#nameHistoryModal").modal("show");
			}, error: (error) => {
				this.vesselNameHistoryLoader = null;
				this.vesselNameHistory = [];
				this.historyVessel = null;
				if (error.status == 401) { return }
				this.toastr.error("Something went wrong", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	closeNameHistoryModal() {
		this.vesselNameHistory = [];
		this.historyVessel = null;
		$("#nameHistoryModal").modal("hide");
	}
}
